<div class="hvac-row">
    <div class="hvac-col-xs-12 hvac-col-lg-6 layer-view-mss-data-details-col">
        <ul class="layer-view-mss-data-detail-list">
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.ID' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].id | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.USER_ID' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userID | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.HVAC_PIN' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].hvacPin | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.COMPANY_ID' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].companyId | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.FIRST_NAME' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].firstName | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.LAST_NAME' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].lastName | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.EMAIL' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].email | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.USER_ADDRESS_1' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userAddress1 | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.USER_ADDRESS_2' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userAddress2 | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.CITY' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userCity | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.COUNTRY' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userCountry | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.STATE' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userState | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.POSTAL_CODE' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userPostalCode | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.PHONE' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userPhone | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.FAX' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userFax | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.CELL_PHONE' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userCellPhone | textFallback }}</div>
            </li>
        </ul>
    </div>
    <div class="hvac-col-xs-12 hvac-col-lg-6 layer-view-mss-data-details-col">
        <ul class="layer-view-mss-data-detail-list">
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.STATUS' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userStatus | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.IS_CBPI' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].iscbpi?.toString() | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.PAGER' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userPager | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.DEACTIVATED_DATE' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].deactivatedDate ? (mssData[0].deactivatedDate | dateTimeTz:'datetime') : '-' }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.HVAC_COMPANY_ID' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].companyId | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.LAST_LOGIN_DATE' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].lastLoginDate ? (mssData[0].lastLoginDate | dateTimeTz:'datetime') : '-' }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.PHONE_EXTENSION' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].userPhone | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.CREATED_BY' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].createdBy | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.CREATED_DATE' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].createdDate ? (mssData[0].createdDate | dateTimeTz:'datetime') : '-' }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.MODIFIED_BY' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].modifiedBy | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.MODIFIED_DATE' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].modifiedDate ? (mssData[0].modifiedDate | dateTimeTz:'datetime') : '-' }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.HVAC_COMPANY_SERVICE' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].hvacCompanyService?.join(', ') | textFallback }}</div>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.REQUIRED_VALIDATION' | translate}}</div>
                <utc-checkbox class="hvac-col-xs layer-view-mss-data-list-value hvac-edit-mode" [checked]="mssData[0].isValidationRequired || false"
                    [disabled]="true" >
                </utc-checkbox>
            </li>
            <li class="hvac-row hvac-top-xs">
                <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.MSS_DATA.LAST_VALIDATED_DATE' | translate}}</div>
                <div class="hvac-col-xs layer-view-mss-data-list-value hvac-non-edit-mode">{{ mssData[0].lastValidatedDate ? (mssData[0].lastValidatedDate | dateTimeTz:'datetime') : '-' }}</div>
            </li>
        </ul>
    </div>
</div>

<div class="hvac-divider"></div>


<div>
    <div class="hvac-mss-roles-feature-data" (click)="toggleRolesAccordion()">
        <div class="hvac-label hvac-label-bold">{{ 'USER_ADMIN.MSS_DATA.ROLES.ROLES' | translate}}</div>
        <utc-svg [ngClass]="{ 'hvac-add-chevron-up': isRolesExpanded }" class="hvac-mss-roles-down-arrow hvac-text-link" src="assets/icons/chevron-down.svg"></utc-svg>
    </div>
    <div class="hvac-mss-table-container" [ngClass]="{'hidden': !isRolesExpanded}">
        <hvac-table class="hvac-mss-table-wrap" [theme]="'zebra'" [responsive]="true">
            <thead>
                <tr>
                    <td>
                        {{ 'USER_ADMIN.MSS_DATA.ROLES.ID' | translate }}
                    </td>
                    <td>
                        {{ 'USER_ADMIN.MSS_DATA.ROLES.NAME' | translate }}
                    </td>
                    <td>
                        {{ 'USER_ADMIN.MSS_DATA.ROLES.APPROVED_BY' | translate }}
                    </td>
                    <td>
                        {{ 'USER_ADMIN.MSS_DATA.ROLES.MODIFIED_BY' | translate }}
                    </td>
                    <td>
                        {{ 'USER_ADMIN.MSS_DATA.ROLES.MODIFIED_DATE' | translate }}
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let role of mssData[0].userRolesDetails">
                    <td class="hvac-user-admin-table-row-data">{{ role.roleId.toString() | textFallback }}</td>
                    <td class="hvac-user-admin-table-row-data">{{ role.roleName | textFallback }}</td>
                    <td class="hvac-user-admin-table-row-data">{{ role.approvedBy | textFallback }}</td>
                    <td class="hvac-user-admin-table-row-data">{{ role.modifiedBy | textFallback }}</td>
                    <td class="hvac-user-admin-table-row-data">{{ role.modifiedDate ? (role.modifiedDate | dateTimeTz:'datetime') : '-' }}</td>
                </tr>
            </tbody>
        </hvac-table>
    </div>
</div>

<div class="hvac-divider"></div>

<div>
    <div class="hvac-mss-roles-feature-data" (click)="toggleFeaturesAccordion()">
        <div class="hvac-label hvac-label-bold">{{ 'USER_ADMIN.MSS_DATA.FEATURES' | translate}}</div>
        <utc-svg [ngClass]="{ 'hvac-add-chevron-up': isFeaturesExpanded }" class="hvac-mss-roles-down-arrow hvac-text-link" src="assets/icons/chevron-down.svg"></utc-svg>
    </div>
    <div class="hvac-mss-table-container" [ngClass]="{'hidden': !isFeaturesExpanded}">
        <hvac-table class="hvac-mss-table-wrap" [theme]="'zebra'" [responsive]="true">
            <thead>
                <tr>
                    <td>
                        {{ 'USER_ADMIN.MSS_DATA.ROLES.ID' | translate }}
                    </td>
                    <td>
                        {{ 'USER_ADMIN.MSS_DATA.ROLES.NAME' | translate }}
                    </td>
                    <td>
                        {{ 'USER_ADMIN.MSS_DATA.ROLES.APPROVED_BY' | translate }}
                    </td>
                    <td>
                        {{ 'USER_ADMIN.MSS_DATA.ROLES.MODIFIED_BY' | translate }}
                    </td>
                    <td>
                        {{ 'USER_ADMIN.MSS_DATA.ROLES.MODIFIED_DATE' | translate }}
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let feature of mssData[0].additionalFeatures">
                    <td class="hvac-user-admin-table-row-data">{{ feature.featureId.toString() | textFallback }}</td>
                    <td class="hvac-user-admin-table-row-data">{{ feature.featureName | textFallback }}</td>
                    <td class="hvac-user-admin-table-row-data">{{ feature.approvedBy | textFallback }}</td>
                    <td class="hvac-user-admin-table-row-data">{{ feature.modifiedBy | textFallback }}</td>
                    <td class="hvac-user-admin-table-row-data">{{ feature.modifiedDate ? (feature.modifiedDate | dateTimeTz:'datetime') : '-' }}</td>
                </tr>
            </tbody>
        </hvac-table>
    </div>
</div>
